import { MDBox } from '../../../../Component/Common/Components/MDBox';
import { Accordion, AccordionDetails, AccordionSummary, Alert, Button, Grid, Typography } from '@mui/material';
import { MDTypography } from '../../../../Component/Common/Components/MDTypography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useEffect, useState } from 'react';
import { VerificationWorkflowService } from '../../../../Component/Api/VerificationAgency/VerificationWorkflow/VerificationWorkflowService';
import React from 'react';
import { DataPageProgressTrackerDto } from '../../../../Component/Model/Dto/VerificationWorkflow';
import { TabSection } from './TabSection';
import { ScorecardDataPages, ScorecardElements, SubmissionTrackerStatus } from '../../../../Component/Model/Enum/BEE123Enums';
import { useHistory } from 'react-router-dom';
import { SmallLoading } from '../../../../Component/Common/Components/Loading/IntermediateLoading';

interface IProps {
    scorecardId: string;
}

export const Elements = (props: IProps) => {
    const history = useHistory();
    const [isLoading, setIsLoading] = React.useState(false);
    const [verificationWorkflowData, setVerificationWorkflowData] = React.useState<DataPageProgressTrackerDto[]>();
    const [expanded, setExpanded] = useState<number | false>(false);
    const [showOhDear, setShowOhDear] = useState<boolean>(false);
    const [lastGroupedElement, setLastGroupedElement] = useState<number>();
    const ohDearDisplayStates = [SubmissionTrackerStatus.Planned, SubmissionTrackerStatus['Submitted, pending VA action'], SubmissionTrackerStatus['Submission rejected']];
    const groupedElements = [ScorecardElements.People, ScorecardElements.Ownership, ScorecardElements['Management Control'], ScorecardElements['Skills Development']];

    const handleAccordionChange = (panel: number) => (_: React.ChangeEvent<{}>, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };

    const findLastGroupedElement = (data: DataPageProgressTrackerDto[]) => {
        const elementIds = data.map(element => element.elementId);
        const commonElements = groupedElements.filter(id => elementIds.includes(id));
        const largestCommonNumber = Math.max(...commonElements);
        setLastGroupedElement(largestCommonNumber);
    }

    const fetchData = async () => {
        try {
            const stepOneId = 1;
            const scorecardId = props.scorecardId;
            let response = await VerificationWorkflowService.GetWorkflowDetails(scorecardId);

            findLastGroupedElement(response.data);
            const peopleDatabasePage = response.data?.find(x => x.elementId === ScorecardElements.People)?.dataPages.find(x => x.dataPageId === ScorecardDataPages['People Database']);
            if (peopleDatabasePage != null && peopleDatabasePage.trackerInfo.length > 0) {
                const stepOne = peopleDatabasePage.trackerInfo.find(x => x.step === stepOneId);
                if (stepOne != null && !stepOne.hasFirstSubmission) {
                    if (ohDearDisplayStates.includes(stepOne.submissionTrackerStatus)) {
                        setShowOhDear(true);
                    }
                    else {
                        setShowOhDear(false);
                    }
                }
            }
            else {
                setShowOhDear(true);
            }

            setVerificationWorkflowData(response.data)

        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        setIsLoading(true);
        fetchData().finally(() => {
            setIsLoading(false);
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const refresh = () => {
        fetchData();
    }

    if (isLoading) {
        return (
            <Grid container justifyContent="center" height="50vh">
                <SmallLoading />
            </Grid>
        );
    }

    return (
        <>
            <MDBox mt={3}>
                <Alert
                    severity="info"
                    action={
                        <Button size="small" onClick={() => {
                            history.push('/academy/digitalContent')
                        }}>
                            Go to Academy
                        </Button>
                    }
                >
                    Discover videos that explain every detail about the verification process in our academy.
                </Alert>
                <Grid container mt={2} mb={2}>
                    {verificationWorkflowData?.map((element, index) => {
                        let isGrouped = groupedElements.includes(element.elementId);
                        return (
                            <Grid item xs={12} key={index} style={{ marginBottom: (isGrouped && element.elementId !== lastGroupedElement) ? '2px' : '16px' }}>
                                <MDBox style={{ borderRadius: "0.75rem" }}>
                                    <Accordion defaultExpanded={false} square={false} style={{ borderRadius: "0.75rem" }} expanded={expanded === index} onChange={handleAccordionChange(index)}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon style={{ color: 'white' }} />}
                                            style={{
                                                backgroundColor: '#4d4f53',
                                                borderTopLeftRadius: '0.75rem',
                                                borderTopRightRadius: '0.75rem',
                                                borderBottomLeftRadius: expanded === index ? '0' : '0.75rem',
                                                borderBottomRightRadius: expanded === index ? '0' : '0.75rem'
                                            }}
                                        >
                                            <Grid container>
                                                <Grid item xs={11}>
                                                    <MDTypography variant="body" color="white">{element.name}</MDTypography>
                                                </Grid>
                                            </Grid>
                                        </AccordionSummary>
                                        <AccordionDetails style={{ backgroundColor: 'white', padding: "16px", borderBottomLeftRadius: '0.75rem', borderBottomRightRadius: '0.75rem' }}>
                                            {
                                                (showOhDear && isGrouped && element.elementId !== ScorecardElements.People) ?
                                                    <MDBox style={{ textAlign: 'center' }}>
                                                        <img
                                                            src={`${process.env.PUBLIC_URL}/img/verificationProcess/Elements/OhDear.svg`}
                                                            alt={'Oh Dear'}
                                                            style={{ maxWidth: '25%', marginTop: '10px' }}>
                                                        </img>
                                                        <MDBox >
                                                            <Typography variant="h4" mt={2} mb={1}>
                                                                Oh dear!
                                                            </Typography>
                                                            <Typography variant="body2" color="secondary" component="span">
                                                                It seems like you haven't had the chance to complete the People section just yet.
                                                                <p>Please take a moment to do so in order to keep things moving smoothly.</p>
                                                            </Typography>
                                                        </MDBox>
                                                    </MDBox> :
                                                    <TabSection scorecardId={props.scorecardId} dataPages={element.dataPages} refresh={refresh} />
                                            }
                                        </AccordionDetails>
                                    </Accordion>
                                </MDBox>
                            </Grid>
                        )
                    })}
                </Grid>
            </MDBox>
        </>
    )
}